import React from "react";
import {
  Box,
  Skeleton,
  Stack,
  type SkeletonProps,
  type SxProps,
  type Theme,
} from "@mui/material";
import { colors } from "../theme/colors";

export interface CustomSkeletonProps {
  loading?: boolean;
  count?: number;
  variant?: SkeletonProps["variant"];
  animation?: SkeletonProps["animation"];
  width?: SkeletonProps["width"];
  height?: SkeletonProps["height"];
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
  spacing?: number;
}

const CustomSkeleton: React.FC<CustomSkeletonProps> = ({
  loading = true,
  count = 1,
  variant = "rounded",
  animation = "wave",
  width = "100%",
  height = 24,
  children,
  sx,
  containerSx,
  spacing = 1,
}) => {
  if (!loading) {
    return <>{children ?? null}</>;
  }

  const skeletonSx = [
    { bgcolor: colors.background.light },
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  const skeletonItems = Array.from({ length: Math.max(count, 1) }, (_, index) => (
    <Skeleton
      key={index}
      variant={variant}
      animation={animation}
      width={width}
      height={height}
      sx={skeletonSx}
    />
  ));

  if (skeletonItems.length === 1) {
    return <Box sx={containerSx}>{skeletonItems}</Box>;
  }

  return (
    <Stack spacing={spacing} sx={containerSx}>
      {skeletonItems}
    </Stack>
  );
};

export default CustomSkeleton;
